import React from "react";
import {
  MdAcUnit,
  MdBatteryAlert,
  MdDirectionsCar,
  MdError,
  MdFlashOff,
  MdKey,
  MdLock,
  MdLockOpen,
  MdLogin,
  MdLogout,
  MdNotifications,
  MdPowerSettingsNew,
  MdSpeed,
  MdThermostat,
  MdTurnRight,
  MdWarning,
} from "react-icons/md";
import "../../styles/common/alertEventIcon.scss";

const containsAny = (value, terms) => terms.some((term) => value.includes(term));

export const getAlertEventPresentation = (event = {}, isTemperature = false) => {
  const eventId = Number(event.eventId ?? event.messageId ?? event.MessageID);
  const name = String(event.eventName || event.messageName || event.name || "").trim().toLowerCase();

  if (isTemperature || containsAny(name, ["temperature", "temp high", "temp low", "over temp", "under temp"])) {
    return { Icon: MdThermostat, tone: name.includes("low") ? "cold" : "temperature", label: "Temperature alert" };
  }
  if (containsAny(name, ["duress", "sos", "panic", "emergency"]) || eventId === 59) {
    return { Icon: MdWarning, tone: "critical", label: "SOS or duress alert" };
  }
  if (containsAny(name, ["engine on", "ignition on"]) || eventId === 4) {
    return { Icon: MdKey, tone: "success", label: "Engine on" };
  }
  if (containsAny(name, ["engine off", "ignition off"]) || eventId === 5) {
    return { Icon: MdPowerSettingsNew, tone: "inactive", label: "Engine off" };
  }
  if (containsAny(name, ["door open", "door unlocked"])) {
    return { Icon: MdLockOpen, tone: "warning", label: "Door open" };
  }
  if (containsAny(name, ["door close", "door locked"])) {
    return { Icon: MdLock, tone: "success", label: "Door closed" };
  }
  if (containsAny(name, ["refrigeration", "fridge", "freezer", "cooling"])) {
    const isOff = containsAny(name, [" off", "stop", "disabled"]);
    return { Icon: MdAcUnit, tone: isOff ? "inactive" : "cold", label: isOff ? "Refrigeration off" : "Refrigeration alert" };
  }
  if (containsAny(name, ["power cut", "power loss", "power disconnect"])) {
    return { Icon: MdFlashOff, tone: "critical", label: "Power disconnected" };
  }
  if (containsAny(name, ["battery", "low volt", "voltage"])) {
    return { Icon: MdBatteryAlert, tone: "warning", label: "Battery or voltage alert" };
  }
  if (containsAny(name, ["speed", "overspeed"])) {
    return { Icon: MdSpeed, tone: "warning", label: "Speed alert" };
  }
  if (eventId === 403 || containsAny(name, ["harsh corner", "harsh turn"])) {
    return { Icon: MdTurnRight, tone: "purple", label: "Harsh cornering" };
  }
  if (eventId === 404 || containsAny(name, ["harsh accel", "rapid accel"])) {
    return { Icon: MdDirectionsCar, tone: "warning", label: "Harsh acceleration" };
  }
  if (eventId === 405 || containsAny(name, ["harsh brak", "rapid decel"])) {
    return { Icon: MdError, tone: "critical", label: "Harsh braking" };
  }
  if (containsAny(name, ["depot entry", "geofence entry", "zone entry", "entered depot", "entered geofence", "entered zone"])) {
    return { Icon: MdLogin, tone: "success", label: name.includes("depot") ? "Depot entry" : "Zone entry" };
  }
  if (containsAny(name, ["depot exit", "geofence exit", "zone exit", "left depot", "left geofence", "left zone"])) {
    return { Icon: MdLogout, tone: name.includes("depot") ? "inactive" : "warning", label: name.includes("depot") ? "Depot exit" : "Zone exit" };
  }

  return { Icon: MdNotifications, tone: "default", label: event.eventName || "Notification" };
};

const AlertEventIcon = ({ event, isTemperature = false, className = "" }) => {
  const { Icon, tone, label } = getAlertEventPresentation(event, isTemperature);

  return (
    <span className={`alert-event-symbol ${tone} ${className}`.trim()} title={label} aria-label={label}>
      <Icon aria-hidden="true" />
    </span>
  );
};

export default AlertEventIcon;
